import { render } from "./base-library-item-small-card.vue?vue&type=template&id=b2a78c0a"
import script from "./base-library-item-small-card.vue?vue&type=script&lang=js"
export * from "./base-library-item-small-card.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__